import { RegisterRequestedFieldType } from "../requested-field-types"
import { RequestedFieldInput, RequestedFieldValue } from "../share-link-fields-slot-definitions"
import { TextFieldInput } from "../text-field-input"
import { TextFieldValue } from "../text-field-value"

/**
 * Self-registering plugin for the "text" requested-field type. Registers the type's metadata in the
 * `RegisterRequestedFieldType` registry and plugs its recipient input + read-only value renderers.
 * Adding a new field type means dropping in a sibling `<type>.runtime.js` like this one — no edits to
 * the host components or the server.
 */
RegisterRequestedFieldType.handleOnce(({ types }) => types.push({ value: "text", label: "Text", priority: 10 }))

RequestedFieldInput("text").plug(<TextFieldInput />)
RequestedFieldValue("text").plug(<TextFieldValue />)
